<script lang="ts">
  // Kurze Meldungen: Erfolge, Taler, Sammelfunde.
  import { toasts } from '../game/profile.ts';
</script>

<div class="toasts" aria-live="polite" data-testid="toasts">
  {#each $toasts as tt (tt.id)}
    <div class="toast {tt.kind}" data-testid="toast">{tt.text}</div>
  {/each}
</div>

<style>
  .toasts {
    position: fixed;
    top: calc(64px + var(--safe-top));
    left: 50%;
    transform: translateX(-50%);
    z-index: 60;
    display: flex;
    flex-direction: column;
    gap: 6px;
    align-items: center;
    pointer-events: none;
    width: min(420px, calc(100% - 24px));
  }
  .toast {
    background: var(--night1, #16243a);
    color: var(--paper, #efe2c4);
    border: 2px solid var(--amber2);
    border-radius: 10px;
    padding: 8px 14px;
    font-weight: 700;
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.4);
    animation: pop 0.35s ease-out;
    text-align: center;
  }
  .toast.coins {
    border-color: var(--amber3);
  }
  .toast.collect {
    border-color: var(--ok);
  }
  @keyframes pop {
    from {
      transform: translateY(-14px) scale(0.9);
      opacity: 0;
    }
  }
  /* Handy quer: Meldungen klein oben rechts (kurz über der Leiste, Klicks gehen durch), damit Frage und „Weiter“ frei bleiben */
  @media (max-height: 500px) {
    .toasts {
      top: calc(6px + var(--safe-top));
      bottom: auto;
      left: auto;
      right: calc(8px + var(--safe-right));
      transform: none;
      width: min(300px, 45vw);
    }
    .toast {
      font-size: 0.8rem;
      padding: 5px 10px;
    }
  }
  @media (prefers-reduced-motion: reduce) {
    .toast {
      animation: none;
    }
  }
</style>
